// Generated by purs version 0.15.15
import * as $foreign from "./foreign.js";
import * as Data_Money_Rounded from "../Data.Money.Rounded/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Restaumatic_Currencies from "../Restaumatic.Currencies/index.js";
var show = /* #__PURE__ */ Data_Show.show(Restaumatic_Currencies.showCurrency);
var currencyOptions = function (v) {
    if (v instanceof Restaumatic_Currencies.PLN) {
        return {
            format: "%n %u",
            precision: 2,
            separator: ",",
            delimiter: " ",
            unit: "z\u0142"
        };
    };
    if (v instanceof Restaumatic_Currencies.CZK) {
        return {
            format: "%n %u",
            precision: 2,
            separator: ",",
            delimiter: "",
            unit: "K\u010d"
        };
    };
    if (v instanceof Restaumatic_Currencies.GBP) {
        return {
            format: "%u%n",
            precision: 2,
            separator: ".",
            delimiter: ",",
            unit: "\xa3"
        };
    };
    if (v instanceof Restaumatic_Currencies.USD) {
        return {
            format: "%u%n",
            precision: 2,
            separator: ".",
            delimiter: "",
            unit: "$"
        };
    };
    if (v instanceof Restaumatic_Currencies.EUR) {
        return {
            format: "%n %u",
            precision: 2,
            separator: ",",
            delimiter: "",
            unit: "EUR"
        };
    };
    if (v instanceof Restaumatic_Currencies.RUB) {
        return {
            format: "%n %u",
            precision: 2,
            separator: ",",
            delimiter: " ",
            unit: "\u0440\u0443\u0431."
        };
    };
    if (v instanceof Restaumatic_Currencies.RON) {
        return {
            format: "%n %u",
            precision: 2,
            separator: ",",
            delimiter: " ",
            unit: "RON"
        };
    };
    if (v instanceof Restaumatic_Currencies.HRK) {
        return {
            format: "%n %u",
            precision: 2,
            separator: ",",
            delimiter: " ",
            unit: "kn"
        };
    };
    if (v instanceof Restaumatic_Currencies.BRL) {
        return {
            format: "%u%n",
            precision: 2,
            separator: ".",
            delimiter: "",
            unit: "R$"
        };
    };
    if (v instanceof Restaumatic_Currencies.RSD) {
        return {
            format: "%n %u",
            precision: 2,
            separator: ",",
            delimiter: ".",
            unit: "\u0440\u0441\u0434"
        };
    };
    throw new Error("Failed pattern match at Restaumatic.I18n.Currency (line 44, column 3 - line 54, column 90): " + [ v.constructor.name ]);
};
var currencyUnit = function ($7) {
    return (function (v) {
        return v.unit;
    })(currencyOptions($7));
};
var formatCurrencyFormal = function (currency) {
    return function (value) {
        return $foreign["_formatCurrency"]((function () {
            var v = currencyOptions(currency);
            return {
                precision: v.precision,
                separator: v.separator,
                delimiter: v.delimiter,
                format: "%u %n",
                unit: show(currency)
            };
        })(), Data_Money_Rounded.toNumber(value));
    };
};
var formatCurrencySimple = function (currency) {
    return function (value) {
        return $foreign["_formatCurrency"](currencyOptions(currency), Data_Money_Rounded.toNumber(value));
    };
};
var formatCurrency = formatCurrencySimple;
var formatCurrencyWithoutUnit = function (currency) {
    return function (value) {
        return $foreign["_formatCurrency"]((function () {
            var v = currencyOptions(currency);
            return {
                format: v.format,
                precision: v.precision,
                separator: v.separator,
                delimiter: v.delimiter,
                unit: ""
            };
        })(), Data_Money_Rounded.toNumber(value));
    };
};
export {
    formatCurrency,
    formatCurrencyFormal,
    formatCurrencyWithoutUnit,
    currencyUnit
};
